<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="flex: 0 0 22%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button active_tab"
                style="height: 80px; width: 80px"
              >
                <h3 class="text-white">{{ companyGroupsCount }}</h3>
              </div>
              <div class="text-center mt-3 bold-text primary-color">
                {{ $t("text.cAsset.totalAsset") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div
              class="row align-items-center d-flex justify-content-center section__row"
            >
              <div class="col-md-7">
                <div class="ml_5">
                  <h5 class="text-white">
                    {{ $t("text.cAsset.title") }}
                  </h5>
                  <div class="mt-4">
                    <span class="text-white grey-para">
                      {{ $t("text.cAsset.desc") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-5 text_right">
                <button
                  class="add__new__retainership_btn primary-color white-bg"
                  style="border-radius: 6px"
                  @click="showCreateModal"
                >
                  {{ $t("text.cAsset.createButton") }}
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    height="35px"
                    class="ml-3 loader"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            class="col-md-12 col-lg-12 mt-3"
            v-show="companyGroups.length > 0 && !showLoader"
          >
            <ejs-grid
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="name"
                  :headerText="$t('text.cAsset.grpName')"
                ></e-column>
                <e-column
                  width="220"
                  field="description"
                  :headerText="$t('text.cAsset.description')"
                ></e-column>
                <e-column
                  width="150"
                  field="groupTypeFormatted"
                  :headerText="$t('text.cAsset.grpType')"
                ></e-column>
                <e-column
                  width="180"
                  field="assetsCount"
                  :headerText="$t('text.cAsset.numAsset')"
                ></e-column>
                <e-column
                  width="100"
                  field="assetsRequiringAttentionCount"
                  :headerText="$t('text.cAsset.assetReq')"
                ></e-column>
                <e-column
                  width="500"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
          <div class="col-md-12 col-lg-12 mt-3">
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <section
        class="products_summary__wrapper pb-5 mt-3"
        v-show="companyGroups.length < 1 && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 30px">
            <h6 style="color: rgb(161, 146, 146); font-size: 13px">
              {{ $t("text.cAsset.noAssetGrp") }}
            </h6>
          </div>

          <div class="text-center pb-5" style="margin-top: 50px">
            <img src="@/assets/img/gold-ingots.svg" width="170" />
          </div>
          <div class="text-center mt-3 pb-4">
            <span
              class="primary-color font-bold cursor_pointer"
              @click="showCreateModal"
              >{{ $t("text.cAsset.createAssGrp") }}</span
            >
          </div>
        </div>
      </section>
    </MasterLayout>
    <CreateAssetGroup></CreateAssetGroup>
    <EditAssetGroup :group="currentData"></EditAssetGroup>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import CreateAssetGroup from "@/components/modals/Assets/createAssetGroup.vue";
import EditAssetGroup from "@/components/modals/Assets/editAssetGroup.vue";
import Temp from "@/components/TableTemplates/assets/companyAssets.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Assets :: Epump Portal",
  name: "Assets",
  components: {
    MasterLayout,
    CreateAssetGroup,
    EditAssetGroup,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      companyGroupsCount: null,
      // company: localStorage.getItem("companyDetails")
      //   ? JSON.parse(localStorage.getItem("companyDetails"))
      //   : null,
      backgroundUrl,
      cardBackgroundUrl,
      companyGroups: [],
      currentData: {},
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      company: null,
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getAssetGroups();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getAssetGroups();
    }
    this.$eventHub.$on("refreshAssetsGroup", () => {
      this.getAssetGroups();
    });
    this.$eventHub.$on("setEditModalValues", (data) => {
      this.currentData = data;
      this.showEditModal();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("refreshAssetsGroup");
    this.$eventHub.$off("setEditModalValues");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    showCreateModal() {
      this.$modal.show("createAssetGroup");
    },
    showEditModal() {
      this.$modal.show("editAssetGroup");
    },
    getAssetGroups() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Assets/asset-groups?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.forEach((cur, index) => {
            cur.index = index + 1;
            cur.groupTypeFormatted =
              cur.groupType == 0 ? "Licenses & Permits" : "Physical";
            cur.date = this.$moment(cur.date).format("D MMMM, YYYY");
          });
          this.showLoader = false;
          this.companyGroups = response.data;
          this.companyGroupsCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
